
<template>
  <div class="thread">
    <div class="top">
        <div class="form">
          <van-form @submit="onSubmit" :show-error-message="false">
            <van-field
              v-model="info.clueContactPhone"
              name="clueContactPhone"
              label="手机号"
              placeholder="输入朋友手机号"
              :rules="[{pattern, required: false, message: '请填写正确手机号' }]"
            />
            <van-field
              v-model="info.clueContactName"
              name="clueContactName"
              label="用户名"
              placeholder="输入朋友称呼"
              :rules="[{ required: false, message: '请填写朋友称呼' }]"
            />
            <van-field
              v-model="info.clueContactCompany"
              name="clueContactCompany"
              label="公司名"
              placeholder="输入朋友公司名"
              :rules="[{ required: false, message: '请填写朋友公司名' }]"
            />
            <div class="submit-box">
              <div class="btn flex-c-c">
                <van-button round block  type="info" native-type="submit">提交线索</van-button>
              </div>
            </div>
          </van-form>
        </div>
        <div class="tips">
            <div class="tips-title">提交须知：</div>
            <div class="each-tip"><img src="../../assets/images/new/1.png" alt=""> 我们将根据您提交的线索进行新客户服务与软件购买跟进。 您推荐的线索将成为您的已推荐名单，您可在首页点击查看推荐</div>
            <div class="each-tip"><img src="../../assets/images/new/2.png" alt="">
        新客户需在推荐绑定前从未在系统内注册试用过方可作为有效</div>
            <div class="each-tip"><img src="../../assets/images/new/3.png" alt=""> 
        如您推荐的客户后期试用购买软件更换登录名称与手机号，请您及时联系您的销售人员/专属客服，我们将手动为您变更。</div>
        </div>
    </div>
  </div>
</template>

<script type="text/babel">
import {ls} from '@/utils/localStorage'
// 组件
export default {
  name: 'threadList',
  data() {
    return {
      info:{
        clueContactPhone:'',
        clueContactName:'',
        clueContactCompany:'',
        pushCustomerId:""
      },
      pattern: /^[1][345789]\d{9}$/,
      publicKey: "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQClWR2VO4ME9kBLeR0mBV8nt/Wi+tN4DqGjxkVS2i9DAJnSfw+/0GwtVQJsyJ9iv9WKW1EC5XfX/kPIudK5+CD5xcpNoxYERsR2pqOx5MLnzY4QtOaF9aIucTjrAJH+wPraWB69OpZJOymj/CwbJovntwWAF5MP5GvNkb3WWVuYgQIDAQAB",
    };
  },
  created() {
    // if(this.$route.query.id) {
    //   this.info.pushCustomerId = this.$route.query.id
    // } else {
      this.info.pushCustomerId = ls.get('userInfo').id||''
    // }
  },
  methods: {
    getPrams() {
      let timer = this.getNowTime();
      let target = this.info
      let str= `clueContactCompany<=>${target.clueContactCompany}<&>clueContactName<=>${target.clueContactName}<&>clueContactPhone<=>${target.clueContactPhone}<&>pushCustomerId<=>${this.info.pushCustomerId}`
      let encrypt = new JSEncrypt();
      console.log(str)
      encrypt.setPublicKey(this.publicKey);
      let enp = encrypt.encryptLong(str);
      let sign = sha256(timer + enp );
      let param = {
        p:enp,
        timeStamp:timer,
        sign:sign,
        sourceId:1
      }
      return param
    },
    validate() {
      if(this.info.clueContactCompany&&this.info.clueContactCompany.length>30) {
        
          this.$toast.success('公司名超出规定长度！');
          return false
      }
      if(this.info.clueContactName&&this.info.clueContactName.length>20) {
        
          this.$toast.success('用户名超出规定长度！');
          return false
      }
      return true
    },
    getNowTime() {
    var date = new Date();
    this.year = date.getFullYear();
    this.month = date.getMonth() + 1;
    this.date = date.getDate();
    this.hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    this.minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    this.second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    var currentTime = this.year + '-' +this.addZero(this.month) + '-' + this.addZero(this.date) + ' ' + this.hour + ':' + this.minute + ':' + this.second;
    return currentTime;
},
    addZero(s) {
    return s < 10 ? ('0' + s) : s;
    },
    onSubmit(values) {
      
      if(!this.validate()) {
        return
      }
      let params={
        clueContactCompany:this.info.clueContactCompany,
        clueContactName:this.info.clueContactName,
        clueContactPhone:this.info.clueContactPhone,
        pushCustomerId:this.info.pushCustomerId
      }
      // let params=this.getPrams()
      this.$services.customerCluesSave({
        method:"POST",
        data:params,
        type:"json"
      }).then(res=> {
        if(res.code==0) {
          this.$toast.success('提交成功');
        } else {
          
          this.$toast.success(res.message);
        }
      })
    }
  }
  }
</script>

<style lang="less" scoped>
.thread{
    .top{
        background: url(../../assets/images/new/bg.png) no-repeat;
        background-size: 100% 100%;
        height: 980px;
        position: relative;
    }
    .form{
        position: absolute;
        top: 400px;
        left: 10%;
        .submit-box{

          .btn{
            background: url(../../assets/images/new/btn.png) no-repeat;
            background-size: 150% 170%;
            background-position: 54% 83%;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-size: 24px;
            height: 100px;
          }
          .van-button--info{
            background: none !important;
            font-size: 24px;
            color: #F33623;
            border:none;
          }
        }
    }
    .tips{
        position: absolute;
        bottom: 0px;
        padding: 14px;
        .tips-title{
            font-size: 18px;
            font-family: Noto Sans S Chinese;
            font-weight: bold;
            color: #000000;
            text-align: left;
            margin-bottom: 8px;
        }
        .each-tip{
            img{
                width: 14px;
                height: 14px;
                margin-right: 4px;
            }
            text-align: left;
        }
    }
}
</style>
